import { createApp } from 'vue'
import { createI18n } from "vue-i18n/dist/vue-i18n.esm-bundler.js"
import { messages } from './i18n/messages'
import { useHttp, setStore, setRouter } from './composables/http'
import { setStore as setWebappStore, setRouter as setWebappRouter } from '@webapp/composables/http'
import router from './router'
import store from './store'

import "bootstrap"
import "./assets/styles.scss"

import App from './App.vue'

import { detectLocale } from './i18n/locales'

export const i18n = createI18n({
    legacy: false,
    locale: detectLocale(),
    fallbackLocale: 'en',
    messages,
})

const app = createApp(App);
const $http = useHttp();
setStore(store);
setRouter(router);
setWebappStore(store);
setWebappRouter(router);
app.config.globalProperties.$axios = $http;
store.$axios = $http;

app
    .use(router)
    .use(i18n)
    .use(store)

app.mount('#app')
